import React from "react"

function Email(props) {
  return (
    <div {...props}>
      <svg
        className="w-full h-full"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="15" cy="15" r="15" fill="#F4F4F4" />
        <path
          d="M22 13.4893V13.7805L19.376 15.6765V10.6238H10.624V15.6765L8 13.7805V13.4893C8 13.0691 8.19523 12.6952 8.50295 12.4569C8.7445 12.2683 8.97282 12.0897 9.31364 11.8349V10.6271C9.31364 9.90247 9.90262 9.31348 10.6273 9.31348H12.7483C12.831 9.25392 12.9104 9.19767 12.9965 9.1348C13.4531 8.79729 14.3663 7.98992 15.0017 7.99985C15.637 7.98992 16.5502 8.79729 17.0102 9.13149C17.0962 9.19436 17.1756 9.25061 17.2583 9.31018H19.3793C20.104 9.31018 20.693 9.89916 20.693 10.6238V11.8316C21.0305 12.0864 21.2621 12.265 21.5037 12.4536C21.8213 12.7018 22.0066 13.0823 22.0066 13.486L22 13.4893ZM16.2822 18.992L22 14.8592V20.6862C22 21.4109 21.411 21.9998 20.6864 21.9998H9.31364C8.58899 21.9998 8 21.4109 8 20.6862V14.8592L13.7178 18.992C14.1016 19.27 14.5516 19.409 14.9983 19.409C15.445 19.409 15.8951 19.27 16.2789 18.992H16.2822ZM12.3744 13.4695V13.0327C12.3744 12.7911 12.5696 12.5959 12.8112 12.5959H17.1855C17.4271 12.5959 17.6223 12.7911 17.6223 13.0327V13.4695C17.6223 13.711 17.4271 13.9063 17.1855 13.9063H12.8112C12.5696 13.9063 12.3744 13.711 12.3744 13.4695ZM12.3744 15.6567C12.3744 15.4151 12.5696 15.2199 12.8112 15.2199H17.1855C17.4271 15.2199 17.6223 15.4151 17.6223 15.6567V16.0934C17.6223 16.335 17.4271 16.5302 17.1855 16.5302H12.8112C12.5696 16.5302 12.3744 16.335 12.3744 16.0934V15.6567Z"
          fill="#A0A0A0"
        />
      </svg>
    </div>
  )
}

export default Email
